// Centralised demo content for Bridge Partners (placeholder, credible)
export const IMAGES = {
  heroAbidjan: "https://images.pexels.com/photos/18435332/pexels-photo-18435332.jpeg",
  abidjanLagoon: "https://images.pexels.com/photos/5642426/pexels-photo-5642426.jpeg",
  cotonouAerial: "https://images.pexels.com/photos/8657935/pexels-photo-8657935.jpeg",
  parisHero: "https://images.unsplash.com/photo-1502602898657-3e91760cbb34?w=1600",
  business1: "https://images.unsplash.com/photo-1758519288358-86c504767112",
  business2: "https://images.unsplash.com/photo-1758519290111-bfbd61b32d49",
};

export const NAV = [
  { label: "Marchés", to: "/marches" },
  { label: "Expertises", to: "/expertises" },
  { label: "Approche", to: "/approche" },
  { label: "Blog", to: "/blog" },
  { label: "À propos", to: "/a-propos" },
  { label: "Nous rejoindre", to: "/nous-rejoindre" },
];

export const STATS = [
  { value: 200, suffix: "+", label: "Projets accompagnés" },
  { value: 50, suffix: "+", label: "Entrepreneurs soutenus" },
  { value: 10, suffix: "+", label: "Partenaires internationaux" },
  { value: 100, suffix: "%", label: "Satisfaction clients" },
];

export const PILLARS = [
  {
    num: "01",
    key: "conseil-entreprises",
    icon: "Building2",
    title: "Conseil aux Entreprises",
    short: "Créer, structurer et développer votre entreprise en Afrique de l'Ouest.",
    context:
      "De l'idée à la croissance, nous structurons votre implantation : choix de la forme juridique, formalités OHADA, gouvernance, financement et développement commercial.",
    services: [
      "Création & domiciliation d'entreprise",
      "Structuration juridique & fiscale (OHADA)",
      "Levée de fonds & relations investisseurs",
      "Développement commercial & partenariats locaux",
    ],
    quote: "Nous ne conseillons pas depuis Paris : nous opérons sur le terrain, à vos côtés.",
    deliverables: ["Business plan & étude de marché", "Statuts & immatriculation OHADA", "Dossier de financement", "Plan de développement 12 mois"],
    kpis: [{ k: "< 30j", v: "Délai de création moyen" }, { k: "150+", v: "Sociétés accompagnées" }],
  },
  {
    num: "02",
    key: "marches-publics",
    icon: "Scale",
    title: "Marchés Publics & Compliance",
    short: "Accéder à la commande publique et sécuriser vos activités.",
    context:
      "La commande publique est un levier de croissance majeur. Nous sécurisons votre accès et votre conformité, de la veille à la contractualisation.",
    services: [
      "Assistance à Maîtrise d'Ouvrage (AMO)",
      "Conformité & lutte anti-corruption",
      "Accompagnement des entreprises candidates",
      "Formation aux procédures de passation",
    ],
    quote: "La conformité n'est pas une contrainte, c'est votre meilleur argument commercial.",
    deliverables: ["Veille des appels d'offres", "Dossiers de candidature complets", "Programme de conformité", "Formation des équipes"],
    kpis: [{ k: "4 axes", v: "AMO · Conformité · Candidature · Formation" }, { k: "100%", v: "Sécurisation des procédures" }],
  },
  {
    num: "03",
    key: "services-numeriques",
    icon: "Cpu",
    title: "Services Numériques",
    short: "Le numérique au service de votre croissance.",
    context:
      "Nous outillons votre développement avec des solutions digitales sur-mesure : présence en ligne, dématérialisation, data et automatisation intelligente.",
    services: [
      "Sites & plateformes web performantes",
      "Dématérialisation des processus",
      "Data & intelligence économique",
      "Automatisation & IA appliquée",
    ],
    quote: "La technologie n'a de valeur que lorsqu'elle sert une stratégie claire.",
    deliverables: ["Sites & plateformes sur-mesure", "Dématérialisation des processus", "Tableaux de bord data", "Automatisations & IA appliquée"],
    kpis: [{ k: "x3", v: "Gain de productivité moyen" }, { k: "24/7", v: "Solutions disponibles" }],
  },
  {
    num: "04",
    key: "analyse-risques",
    icon: "ShieldCheck",
    title: "Analyse des Risques & Intelligence Stratégique",
    short: "Anticiper les menaces — protéger les institutions.",
    context:
      "Intelligence économique, due diligence et gestion de crise : nous éclairons vos décisions dans des environnements complexes et changeants.",
    services: [
      "Due diligence & vérification de partenaires",
      "Cartographie des risques pays & secteur",
      "Veille stratégique & intelligence économique",
      "Gestion de crise & continuité d'activité",
    ],
    quote: "Anticiper, c'est déjà décider. L'information stratégique change l'issue.",
    deliverables: ["Rapports de due diligence", "Cartographie des risques", "Notes d'intelligence économique", "Plan de gestion de crise"],
    kpis: [{ k: "48h", v: "Première alerte risque" }, { k: "360°", v: "Couverture d'analyse" }],
  },
];

export const PARTNERS = [
  "OECCA", "BCEAO", "UEMOA", "CEDEAO", "OHADA", "CCI Bénin",
];

export const PROFILES = [
  { title: "Vous avez un projet pour le pays", desc: "Concrétisez votre ambition avec un accompagnement structuré, de la création au déploiement.", to: "/expertises" },
  { title: "Vous cherchez une opportunité en Afrique", desc: "Identifiez les marchés porteurs et sécurisez votre entrée grâce à notre ancrage local.", to: "/marches" },
  { title: "Vous voulez passer un cap", desc: "Structurez votre croissance, ouvrez de nouveaux marchés et professionnalisez vos process.", to: "/approche" },
  { title: "Vous faites face à des enjeux complexes", desc: "Compliance, risques, intelligence stratégique : sécurisez vos décisions les plus sensibles.", to: "/expertises" },
];

export const TESTIMONIALS = [
  { name: "Awa Koné", role: "Fondatrice, AgriTech Abidjan", quote: "Bridge Partners a transformé une idée en entreprise structurée en moins de six mois. Un interlocuteur unique, une exécution sans faille.", initials: "AK" },
  { name: "Marc Dossou", role: "DG, groupe logistique — Cotonou", quote: "Leur maîtrise de la commande publique nous a ouvert des marchés inaccessibles jusque-là. Rigueur européenne, connaissance du terrain.", initials: "MD" },
  { name: "Sophie Lemoine", role: "Investisseuse, diaspora Paris", quote: "J'investis en Côte d'Ivoire en confiance. La due diligence et l'intelligence économique de l'équipe sont d'un niveau rare.", initials: "SL" },
  { name: "Ibrahim Touré", role: "Directeur institutionnel", quote: "Un partenaire stratégique qui comprend nos contraintes et anticipe les risques. La confidentialité est absolue.", initials: "IT" },
];

export const COUNTRIES = [
  {
    key: "france", flag: "🇫🇷", name: "France & Outre-mer", city: "Paris",
    tag: "Base européenne",
    image: IMAGES.parisHero,
    desc: "Ancrage européen de Bridge Partners, la France et les Outre-mer constituent le pont naturel entre la diaspora, les investisseurs et les marchés africains — un accès direct à l'écosystème financier, juridique et institutionnel européen.",
    stats: [
      { k: "68M+", v: "Habitants (Hexagone + DOM)" }, { k: "7ᵉ", v: "Économie mondiale" },
      { k: "5", v: "Territoires ultramarins" }, { k: "#1", v: "Diaspora afro-européenne" },
    ],
    atouts: ["Passerelle Europe ↔ Afrique", "Écosystème financier & juridique mature", "Diaspora active & entrepreneuriale", "Réseau institutionnel (OIF, AFD, Bpifrance)"],
    events: [
      { year: "2025", label: "Nouveau plan d'investissement France–Afrique" },
      { year: "2024", label: "Sommet Ambition Africa & partenariats renforcés" },
      { year: "2023", label: "Élargissement de la stratégie Outre-mer" },
    ],
    gallery: [
      { url: "https://images.pexels.com/photos/699466/pexels-photo-699466.jpeg", caption: "La Tour Eiffel — Paris" },
      { url: "https://images.pexels.com/photos/2412603/pexels-photo-2412603.jpeg", caption: "Le Louvre & la Seine — Paris" },
      { url: "https://images.pexels.com/photos/2549018/pexels-photo-2549018.jpeg", caption: "Marseille, porte de la Méditerranée" },
      { url: "https://images.pexels.com/photos/1450353/pexels-photo-1450353.jpeg", caption: "Antilles françaises — Guadeloupe / Martinique" },
      { url: "https://images.pexels.com/photos/3593922/pexels-photo-3593922.jpeg", caption: "La Réunion — reliefs volcaniques" },
    ],
  },
  {
    key: "benin", flag: "🇧🇯", name: "Bénin", city: "Cotonou",
    tag: "Ancrage historique",
    image: IMAGES.cotonouAerial,
    desc: "Berceau de nos activités, le Bénin est une terre de réformes, portée par la digitalisation de l'administration et un climat des affaires en pleine modernisation.",
    stats: [
      { k: "6,4%", v: "Croissance PIB" }, { k: "13M+", v: "Habitants" },
      { k: "Top 3", v: "Réformes UEMOA" }, { k: "#1", v: "Port de Cotonou régional" },
    ],
    atouts: ["Guichet unique de formalisation", "Digitalisation des services publics", "Position de hub portuaire régional", "Stabilité institutionnelle"],
    events: [
      { year: "2024", label: "Accélération de la dématérialisation des marchés publics" },
      { year: "2023", label: "Réforme du code des investissements" },
      { year: "2025", label: "Nouveaux corridors logistiques régionaux" },
    ],
    gallery: [
      { url: "https://upload.wikimedia.org/wikipedia/commons/thumb/5/53/Le_monument_de_l%27Amazone.jpg/1920px-Le_monument_de_l%27Amazone.jpg", caption: "Le Monument de l'Amazone — Cotonou" },
      { url: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d7/Vue_panoramique_quartier_cadj%C3%A9houn-Cotonou_au_B%C3%A9nin_1.jpg/1920px-Vue_panoramique_quartier_cadj%C3%A9houn-Cotonou_au_B%C3%A9nin_1.jpg", caption: "Panorama de Cotonou (Cadjéhoun)" },
      { url: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/28/The_city_of_Ouidah.jpg/1920px-The_city_of_Ouidah.jpg", caption: "Ouidah, ville historique et culturelle" },
      { url: "https://images.pexels.com/photos/8657935/pexels-photo-8657935.jpeg", caption: "Ganvié, la cité lacustre" },
      { url: "https://images.pexels.com/photos/159888/pexels-photo-159888.jpeg", caption: "Textiles & artisanat" },
    ],
  },
  {
    key: "cote-ivoire", flag: "🇨🇮", name: "Côte d'Ivoire", city: "Abidjan",
    tag: "Hub stratégique",
    image: IMAGES.heroAbidjan,
    desc: "Première économie de l'UEMOA, la Côte d'Ivoire est le hub d'affaires incontournable de l'Afrique de l'Ouest francophone, moteur d'innovation et d'investissement.",
    stats: [
      { k: "7%", v: "Croissance PIB" }, { k: "29M+", v: "Habitants" },
      { k: "40%", v: "PIB de l'UEMOA" }, { k: "#1", v: "Économie francophone régionale" },
    ],
    atouts: ["Marché intérieur dynamique", "Écosystème d'investissement mature", "Infrastructures de classe régionale", "Hub tech & fintech en expansion"],
    events: [
      { year: "2025", label: "Nouveau plan national de développement" },
      { year: "2024", label: "Expansion du hub technologique d'Abidjan" },
      { year: "2023", label: "Programmes d'attractivité des investisseurs" },
    ],
    gallery: [
      { url: "https://commons.wikimedia.org/wiki/Special:FilePath/Basilique%20notre%20Dame%20de%20la%20Paix%20de%20Yamoussoukro%2020.jpg?width=1600", caption: "Basilique Notre-Dame de la Paix — Yamoussoukro" },
      { url: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3b/Cath%C3%A9drale_Saint-Paul_d%27Abidjan_en_vue_panoramique.jpg/1920px-Cath%C3%A9drale_Saint-Paul_d%27Abidjan_en_vue_panoramique.jpg", caption: "Cathédrale Saint-Paul — Abidjan" },
      { url: "https://upload.wikimedia.org/wikipedia/commons/thumb/5/57/Abidjan_Plateau.png/1920px-Abidjan_Plateau.png", caption: "Le Plateau, cœur d'affaires d'Abidjan" },
      { url: "https://images.pexels.com/photos/18435332/pexels-photo-18435332.jpeg", caption: "Skyline d'Abidjan" },
      { url: "https://images.pexels.com/photos/5642426/pexels-photo-5642426.jpeg", caption: "Abidjan & la lagune Ébrié" },
    ],
  },
];

export const EXPANSION = ["Sénégal", "Togo", "Gh", "Nigeria"];
export const EXPANSION_MARKETS = ["Sénégal", "Togo", "Ghana", "Nigeria"];

export const APPROACH_STEPS = [
  { num: "01", icon: "Ear", title: "Écoute & Diagnostic", desc: "Nous comprenons vos objectifs, contraintes et environnement avant toute recommandation." },
  { num: "02", icon: "PenTool", title: "Proposition sur-mesure", desc: "Une feuille de route claire, chiffrée et adaptée à votre réalité de terrain." },
  { num: "03", icon: "Rocket", title: "Mise en œuvre", desc: "Exécution opérationnelle avec un interlocuteur unique et des jalons mesurables." },
  { num: "04", icon: "BarChart3", title: "Suivi & Reporting", desc: "Tableaux de bord réguliers et transparence totale sur l'avancement." },
  { num: "05", icon: "Infinity", title: "Accompagnement continu", desc: "Un partenariat durable qui grandit avec votre ambition." },
];

export const CONTINENT_STATS = [
  { value: "1,4", suffix: " Md", label: "Population africaine" },
  { value: "6,4", suffix: " %", label: "Croissance du Bénin" },
  { value: "7", suffix: " %", label: "Croissance Côte d'Ivoire" },
  { value: "1,3", suffix: " Md+", label: "Marché ZLECAf" },
];

export const REASONS = [
  { icon: "Landmark", title: "Base européenne France & Outre-mer", desc: "Paris + Outre-mer, accès direct à l'écosystème financier et institutionnel européen (AFD, Bpifrance, OIF)." },
  { icon: "Handshake", title: "Au service de la diaspora", desc: "Un pont naturel entre l'Europe et l'Afrique : nous portons les ambitions de la diaspora vers le terrain." },
  { icon: "MapPin", title: "Ancrage Afrique de l'Ouest", desc: "Une présence réelle à Cotonou et Abidjan, pas une expertise à distance." },
  { icon: "User", title: "Interlocuteur unique", desc: "Un point de contact qui coordonne l'ensemble de vos projets." },
  { icon: "Layers", title: "Expertise multidisciplinaire", desc: "Droit, finance, numérique et intelligence stratégique réunis." },
  { icon: "Network", title: "Réseau de partenaires sélectionnés", desc: "Un écosystème d'institutions et d'experts de confiance." },
  { icon: "Lock", title: "Confidentialité absolue", desc: "Vos informations sensibles sont protégées à chaque étape." },
  { icon: "Target", title: "Engagement résultats", desc: "Nous nous mesurons à vos succès, pas à nos livrables." },
];

export const VALUES = [
  { icon: "ShieldCheck", title: "Intégrité", desc: "Une éthique sans compromis dans chaque mission." },
  { icon: "Award", title: "Excellence", desc: "Les standards européens appliqués au terrain africain." },
  { icon: "Handshake", title: "Proximité", desc: "Une relation humaine, présente et disponible." },
  { icon: "Lock", title: "Confidentialité", desc: "La discrétion comme fondement de la confiance." },
];

export const TIMELINE = [
  { year: "2020", title: "La genèse — Paris", desc: "Naissance de Bridge Partners en France : la conviction qu'une expertise européenne peut créer un pont solide vers l'Afrique." },
  { year: "2021", title: "Premiers pas à Cotonou", desc: "Implantation au Bénin, premières missions de conseil pour la diaspora et les entrepreneurs locaux." },
  { year: "2022", title: "Expansion Côte d'Ivoire", desc: "Ouverture du bureau d'Abidjan, hub stratégique régional de l'UEMOA." },
  { year: "2023", title: "Ancrage France & Outre-mer", desc: "Consolidation de la base parisienne et déploiement d'une offre dédiée aux territoires ultramarins (Antilles, Réunion, Guyane, Mayotte)." },
  { year: "2024", title: "Structuration des pôles", desc: "Formalisation des quatre pôles d'expertise complémentaires : Conseil, Marchés publics, Numérique, Intelligence stratégique." },
  { year: "2025", title: "Trois zones · 200+ projets", desc: "Partenariats institutionnels renforcés (AFD, OIF, Bpifrance) et cap sur les 3 zones d'ancrage : France & Outre-mer · Bénin · Côte d'Ivoire." },
];

export const TEAM = [
  { name: "Kevin A.", role: "Fondateur & Associé", bio: "Stratégie d'entreprise et développement des marchés africains.", tags: ["Stratégie", "Investissement", "OHADA"], img: IMAGES.business1 },
  { name: "Nadia B.", role: "Directrice Compliance", bio: "Marchés publics, conformité et lutte anti-corruption.", tags: ["Compliance", "Marchés publics"], img: IMAGES.business2 },
  { name: "Yao K.", role: "Lead Intelligence Stratégique", bio: "Due diligence, veille et gestion des risques pays.", tags: ["Risques", "Intelligence économique"], img: IMAGES.business1 },
  { name: "Léa M.", role: "Responsable Numérique", bio: "Solutions digitales, data et automatisation intelligente.", tags: ["Digital", "Data", "IA"], img: IMAGES.business2 },
];

export const ARTICLES = [
  { id: 1, category: "Côte d'Ivoire", date: "12 déc. 2025", read: "6 min", title: "Abidjan, nouvel épicentre de la tech ouest-africaine", excerpt: "Comment la capitale économique ivoirienne attire investisseurs et talents dans un écosystème en pleine effervescence.", img: IMAGES.heroAbidjan, featured: true },
  { id: 2, category: "Bénin", date: "5 déc. 2025", read: "4 min", title: "Marchés publics au Bénin : ce que change la dématérialisation", excerpt: "Un tournant pour les entreprises candidates : plus de transparence, de nouvelles règles à maîtriser.", img: IMAGES.cotonouAerial },
  { id: 3, category: "ZLECAf", date: "28 nov. 2025", read: "7 min", title: "ZLECAf : un marché de 1,3 milliard de consommateurs", excerpt: "Les clés pour positionner votre entreprise sur la plus grande zone de libre-échange du monde.", img: IMAGES.abidjanLagoon },
  { id: 4, category: "Investissement", date: "20 nov. 2025", read: "5 min", title: "Diaspora : investir en Afrique sans se tromper", excerpt: "Due diligence, structuration, fiscalité : le guide pratique de l'investisseur averti.", img: IMAGES.business1 },
];

// Country photo galleries (verified free-license photography)
export const COUNTRY_GALLERIES = {
  benin: [
    { url: "https://images.pexels.com/photos/8657935/pexels-photo-8657935.jpeg", caption: "Ganvié, la cité lacustre" },
    { url: "https://images.pexels.com/photos/2088170/pexels-photo-2088170.jpeg", caption: "Marchés & commerce" },
    { url: "https://images.pexels.com/photos/2544554/pexels-photo-2544554.jpeg", caption: "Artisanat & textiles" },
    { url: "https://images.pexels.com/photos/159888/pexels-photo-159888.jpeg", caption: "Route côtière" },
    { url: "https://images.unsplash.com/photo-1580060839134-75a5edca2e99", caption: "Vie urbaine à Cotonou" },
    { url: "https://images.pexels.com/photos/2662116/pexels-photo-2662116.jpeg", caption: "Héritage & culture" },
  ],
  "cote-ivoire": [
    { url: "https://images.pexels.com/photos/18435332/pexels-photo-18435332.jpeg", caption: "Skyline d'Abidjan" },
    { url: "https://images.pexels.com/photos/5642426/pexels-photo-5642426.jpeg", caption: "La lagune Ébrié" },
    { url: "https://images.unsplash.com/photo-1516026672322-bc52d61a55d5", caption: "Business district" },
    { url: "https://images.pexels.com/photos/2467558/pexels-photo-2467558.jpeg", caption: "Port & commerce" },
    { url: "https://images.unsplash.com/photo-1547471080-7cc2caa01a7e", caption: "Marché animé" },
    { url: "https://images.pexels.com/photos/2422461/pexels-photo-2422461.jpeg", caption: "Culture & patrimoine" },
  ],
};

// Strategic dashboard chart data (Bridge Partners zones + Africa regional context)
export const ZONES_GDP = [
  { zone: "France", pib: 1.1, flag: "🇫🇷" },
  { zone: "Outre-mer", pib: 2.5, flag: "🇫🇷" },
  { zone: "Bénin", pib: 6.4, flag: "🇧🇯" },
  { zone: "Côte d'Ivoire", pib: 7.0, flag: "🇨🇮" },
  { zone: "Afr. Ouest", pib: 5.8, flag: "🌍" },
];

// Kept for backward compatibility if referenced elsewhere
export const GDP_BY_REGION = [
  { region: "Ouest", pib: 5.8 },
  { region: "Est", pib: 5.1 },
  { region: "Centrale", pib: 4.0 },
  { region: "Australe", pib: 2.6 },
  { region: "Nord", pib: 3.4 },
];

export const SECTOR_SPLIT = [
  { name: "Services", value: 48 },
  { name: "Industrie", value: 29 },
  { name: "Agriculture", value: 23 },
];

export const CHART_COLORS = ["#00165F", "#D4A017", "#6B7A99"];

// Extended expertise detail (deliverables + KPIs) per pillar
export const PILLAR_DETAILS = {
  "conseil-entreprises": {
    deliverables: ["Business plan & modélisation financière", "Statuts & immatriculation OHADA", "Plan de développement commercial", "Dossier de financement bancable"],
    kpis: [{ k: "-40%", v: "Délai de création" }, { k: "x2", v: "Taux de financement" }],
  },
  "marches-publics": {
    deliverables: ["Cartographie des appels d'offres", "Dossiers de candidature conformes", "Programme de conformité anti-corruption", "Formation des équipes achats"],
    kpis: [{ k: "+65%", v: "Taux de sélection" }, { k: "100%", v: "Conformité audits" }],
  },
  "services-numeriques": {
    deliverables: ["Sites & plateformes web", "Dématérialisation des processus", "Tableaux de bord data", "Automatisations IA sur-mesure"],
    kpis: [{ k: "-50%", v: "Temps administratif" }, { k: "+30%", v: "Conversion en ligne" }],
  },
  "analyse-risques": {
    deliverables: ["Rapports de due diligence", "Cartographie des risques pays", "Veille stratégique continue", "Plans de gestion de crise"],
    kpis: [{ k: "24/7", v: "Veille stratégique" }, { k: "360°", v: "Vue des risques" }],
  },
};

export const CONTACT = {
  phone: "+33 6 17 05 57 35",
  email: "contact@bridgepartners.fr",
  address: "102 Avenue des Champs-Élysées, 75008 Paris, France",
  locations: "France (Paris & Outre-mer) · Bénin (Cotonou) · Côte d'Ivoire (Abidjan)",
};
